/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { InsertCuepointYoutubeIntegrationCuepointsMutationRequest, InsertCuepointYoutubeIntegrationCuepointsMutationResponse, InsertCuepointYoutubeIntegrationCuepointsPathParams } from "../models/InsertCuepointYoutubeIntegrationCuepoints";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { insertCuepointYoutubeIntegrationCuepoints } from "../axios/insertCuepointYoutubeIntegrationCuepoints";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const insertCuepointYoutubeIntegrationCuepointsMutationKey = () => ["web-app-bff-api", { url: '/youtube-cuepoints/:station' }] as const

export type InsertCuepointYoutubeIntegrationCuepointsMutationKey = ReturnType<typeof insertCuepointYoutubeIntegrationCuepointsMutationKey>

export function insertCuepointYoutubeIntegrationCuepointsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<InsertCuepointYoutubeIntegrationCuepointsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = insertCuepointYoutubeIntegrationCuepointsMutationKey()
        return mutationOptions<InsertCuepointYoutubeIntegrationCuepointsMutationResponse, ResponseErrorConfig<Error>, {station: InsertCuepointYoutubeIntegrationCuepointsPathParams["station"], data: InsertCuepointYoutubeIntegrationCuepointsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ station, data }) => {
            return insertCuepointYoutubeIntegrationCuepoints(station, data, config)
          },
        })

}

/**
 * @description Resolves channel and live video from station settings (with legacy youtubeChannelId fallback), optional body `liveVideoId`, and active live registry. `cueType` is always `cueTypeAd`.
 * @summary Insert an ad cuepoint for the station live broadcast
 * {@link /youtube-cuepoints/:station}
 */
export function useInsertCuepointYoutubeIntegrationCuepoints<TContext>(options: 
{
  mutation?: UseMutationOptions<InsertCuepointYoutubeIntegrationCuepointsMutationResponse, ResponseErrorConfig<Error>, {station: InsertCuepointYoutubeIntegrationCuepointsPathParams["station"], data: InsertCuepointYoutubeIntegrationCuepointsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<InsertCuepointYoutubeIntegrationCuepointsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? insertCuepointYoutubeIntegrationCuepointsMutationKey()

          const baseOptions = insertCuepointYoutubeIntegrationCuepointsMutationOptions(config) as UseMutationOptions<InsertCuepointYoutubeIntegrationCuepointsMutationResponse, ResponseErrorConfig<Error>, {station: InsertCuepointYoutubeIntegrationCuepointsPathParams["station"], data: InsertCuepointYoutubeIntegrationCuepointsMutationRequest}, TContext>
          

          return useMutation<InsertCuepointYoutubeIntegrationCuepointsMutationResponse, ResponseErrorConfig<Error>, {station: InsertCuepointYoutubeIntegrationCuepointsPathParams["station"], data: InsertCuepointYoutubeIntegrationCuepointsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<InsertCuepointYoutubeIntegrationCuepointsMutationResponse, ResponseErrorConfig<Error>, {station: InsertCuepointYoutubeIntegrationCuepointsPathParams["station"], data: InsertCuepointYoutubeIntegrationCuepointsMutationRequest}, TContext>
      
}